module.exports = __webpack_public_path__ + "img/history-1.8277d443.png";